import { render, staticRenderFns } from "./AnalysisList.vue?vue&type=template&id=1a24063a&scoped=true"
import script from "./AnalysisList.vue?vue&type=script&lang=js"
export * from "./AnalysisList.vue?vue&type=script&lang=js"
import style0 from "./AnalysisList.vue?vue&type=style&index=0&id=1a24063a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a24063a",
  null
  
)

export default component.exports